// Simple toast implementation for CommodityBookWebsite
export const useToast = () => {
    const showToast = (message: string, type: 'success' | 'error' = 'success', duration?: number) => {
        // Simple console implementation for now - can be enhanced later
        console.log(`[${type.toUpperCase()}] ${message} ${duration ? `(${duration}ms)` : ''}`);

        // You can implement a proper toast UI component here if needed
        // For now, just using console to maintain compatibility
    };

    const toastSuccess = (text: string) => {
        showToast(text, 'success');
    };

    const toastError = (text: string, duration?: number) => {
        showToast(text, 'error', duration);
    };

    return { toastSuccess, toastError };
};